import { render, staticRenderFns } from "./SorguOneriList.vue?vue&type=template&id=6bc9eb01"
import script from "./SorguOneriList.vue?vue&type=script&lang=ts"
export * from "./SorguOneriList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports